import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class BookingsItems {
  @IsNumber()
  @Expose()
  id!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  bookingItemGroupId!: null | number;
  @IsBoolean()
  @Expose()
  isRefund!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  agentId!: null | string;
  @IsOptional()
  @IsString()
  @Expose()
  friendlyName!: null | string;
  @IsOptional()
  @IsString()
  @Expose()
  creationDate!: string | null;
  @IsNumber()
  @Expose()
  fareBase!: number;
  @IsNumber()
  @Expose()
  grandTotal!: number;
  @IsOptional()
  @IsString()
  @Expose()
  purchasePriceWithCurrency!: string | null;
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  passengerName!: string;
  @IsOptional()
  @IsString()
  @Expose()
  ticketNumber!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  formOfPayment!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  itinerary!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  comment!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  userName!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  freeText!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  orderId!: string | null;
  @IsBoolean()
  @Expose()
  isVoided!: boolean;
  @IsBoolean()
  @Expose()
  isAutomaticallyInvoiced!: boolean;
  @IsBoolean()
  @Expose()
  bookingItemIsSelected!: boolean;
  @IsString()
  @Expose()
  serviceTypeCode!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  status!: number;
  @IsBoolean()
  @Expose()
  isBlockedToInvoiced!: boolean;
  @IsBoolean()
  @Expose()
  hasCostDocumentFile!: boolean;
  @IsBoolean()
  @Expose()
  canSelect!: boolean;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsArray()
  @Expose()
  dateOfYourStay!: string[];
  @IsArray()
  @Expose()
  vendor!: string[];
  @IsOptional()
  @IsString()
  @Expose()
  terminalOfficeId!: string;
  @IsOptional()
  @IsString()
  @Expose()
  printingOfficeId!: string;
  @IsOptional()
  @IsString()
  @Expose()
  groupComment!: string;
}

export class TotalCurrency {
  @IsNumber()
  @Expose()
  total!: number;
  @IsString()
  @Expose()
  currency!: string;
}

export class BookingsListItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsBoolean()
  @Expose()
  canSelect!: boolean;
  @IsString()
  @Expose()
  recordLocator!: string;
  @IsString()
  @Expose()
  gds!: string;
  @IsBoolean()
  @Expose()
  bookingIsSelected!: boolean;
  @IsString()
  @Expose()
  contractor!: string;
  @Type(() => TotalCurrency)
  @ValidateNested()
  @Expose()
  grossItems!: Array<TotalCurrency>;
  @Type(() => TotalCurrency)
  @ValidateNested()
  @Expose()
  purchaseItems!: Array<TotalCurrency>;
  @Type(() => BookingsItems)
  @ValidateNested()
  @Expose()
  bookingItems!: Array<BookingsItems>;
}

export class BookingsListResponse extends GenericTableResponse<BookingsListItem> {
  @Type(() => BookingsListItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BookingsListItem>;
}
